import { call, put, takeEvery } from "redux-saga/effects";
import { INTERNET_CONNECTION_INIT_START, INTERNET_CONNECTION_MEASURE_SPEED_START } from "./internetConnectionConstants";
import axios from "axios";
import {
    internetConnectionInitSuccess,
    internetConnectionMeasureSpeedFailure,
    internetConnectionMeasureSpeedSuccess
} from "./internetConnectionActions";
import { failurePut } from "../../app/failurePut";
import _ from "lodash";
import { logAction } from "../../app/appActions";
import { PUBLIC_URL } from "../../config";

const axiosInstance = axios.create();

function* internetConnectionMeasureSpeedSaga() {
    try {
        const startTime = (new Date()).getTime();
        const data = yield call(axiosInstance, `${PUBLIC_URL}/assets/test-connection.png`, {
            responseType: 'blob',
        });
        const downloadSize = data.data?.size || 0;
        const endTime = (new Date()).getTime();
        const duration = (endTime - startTime) / 1000;
        const bitsLoaded = downloadSize * 8;
        const speedBps = bitsLoaded / duration;
        const speedKbps = speedBps / 1024;
        yield put(internetConnectionMeasureSpeedSuccess(_.round(speedKbps, 2)));
        yield put(logAction({
            operation: 'internet_connection_measure_speed',
            speedKbps,
        }));
    } catch (e) {
        yield call(failurePut, e, internetConnectionMeasureSpeedFailure);
    }
}

function* internetConnectionInitSaga() {
    yield call(internetConnectionMeasureSpeedSaga);
    yield put(internetConnectionInitSuccess());
}

export function* internetConnectionSagas() {
    yield takeEvery(INTERNET_CONNECTION_MEASURE_SPEED_START, internetConnectionMeasureSpeedSaga);
    yield takeEvery(INTERNET_CONNECTION_INIT_START, internetConnectionInitSaga);
}
